import { mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { ICustomFilter, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';

export const upsertCustomLayout = async (data: Record<string, unknown>) =>
  partfinitiClient.postForm('/layout/custom-layout-edit/save', data);

export const removeCustomLayout = async (data: Record<string, unknown>) =>
  partfinitiClient.postForm('/layout/custom-layout-edit/remove', data);

export const getCustomFilters = async (payload: IRequestPayload, signal?: AbortSignal) => {
  const { data } = await partfinitiClient.get(
    `/filter/custom-filter/list?${getQueryStringToSnakeCase(payload)}`,
    signal
  );

  return mapRecordsFromServer<ICustomFilter>(data.data, data.recordsFiltered);
};

export const upsertCustomFilter = async (data: Partial<ICustomFilter>) =>
  partfinitiClient.postForm('/filter/custom-filter-edit/save', {
    customTableFilter: data,
  });

export const removeCustomFilter = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/filter/custom-filter-edit/remove', data);
